import { createMemo } from "solid-js"
import type { RiverEntity } from "../../lib/core/entity/EntityType/River"
import { isEntityRiver } from "../../lib/core/entity/entityTypeMetaList.generated"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { useSharedWaterEntsListMemo } from "./useSharedWaterEntsListMemo"

// return all river water ents
export const useSharedRiverEntsListMemo = createSharedCachedFactory((engine) => {

  const getWaterEntsList = useSharedWaterEntsListMemo(engine)

  const getRiverEntsList = createMemo<Array<RiverEntity>>(() => {
    const waterEnts = getWaterEntsList()
    return waterEnts.filter(isEntityRiver)
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('getRiverEntsList', getRiverEntsList())
  // })

  return getRiverEntsList
})
